"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const InlineCheckBok_1 = tslib_1.__importDefault(require("src/components/chekboks/InlineCheckBok"));
const Permissions = (props) => {
    return ((0, jsx_runtime_1.jsx)("div", { style: { paddingLeft: 25 }, children: props.items.map((el, index) => {
            return ((0, jsx_runtime_1.jsx)("div", { className: 'checkbox-list', children: (0, jsx_runtime_1.jsx)(InlineCheckBok_1.default, { label: el.title, name: `permissionGroups[${props.index}].groupPermissions[${index}].checked`, onChange: (name, value) => {
                        const everyItems = props.items.every(permission => {
                            if (permission.name === el.name)
                                return value;
                            return permission.checked;
                        });
                        const everyGroupItems = props.values.permissionGroups.every(group => {
                            if (group.groupName === props.values.permissionGroups[props.index].groupName)
                                return everyItems;
                            return group.checked;
                        });
                        props.setFieldValue(name, value);
                        props.setFieldValue(`permissionGroups[${props.index}].checked`, everyItems);
                        props.setFieldValue('selectedAll', everyGroupItems);
                    }, value: el.checked }) }, el.id));
        }) }));
};
exports.default = Permissions;
